import { render } from "./size-guide-btn.vue?vue&type=template&id=d1119030"
import script from "./size-guide-btn.vue?vue&type=script&lang=js"
export * from "./size-guide-btn.vue?vue&type=script&lang=js"

import "./size-guide-btn.vue?vue&type=style&index=0&id=d1119030&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__